module.exports = __webpack_public_path__ + "static/media/online-report.779f60f4.svg";